import * as React from 'react';
import { PanelRow, PanelCell, Grid, Cell, Icon, Field, Button } from '@teamsnap/teamsnap-ui';

export interface Props {
  legacyOrg: any;
  setAddLegacySeasons: React.Dispatch<React.SetStateAction<boolean>>;
  addLegacySeasons: boolean;
  hasLegacySeasonConnected: boolean;
}

const OrgEditLegacySeasonField: React.FunctionComponent<Props> = ({
  legacyOrg,
  setAddLegacySeasons,
  addLegacySeasons,
  hasLegacySeasonConnected,
}) => (
  <PanelRow isWithCells={true} mods="Panel-row--header">
    <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
      <h4>Club & League UUID</h4>
    </PanelCell>
    <PanelCell mods="u-size9of12">
      <Grid isWithGutter={true}>
        <Cell mods="u-size12of12">
          <button
            key={legacyOrg.id}
            disabled
            type="button"
            className="u-padSidesMd u-padEndsSm u-spaceTopMd u-border u-borderRadiusMd u-borderColorDefault u-textLeft"
          >
            <span className="u-block u-fontSizeLg">{legacyOrg.name}</span>
            <span className="u-spaceXs u-block u-fontSizeSm">{legacyOrg.id}</span>
          </button>
          <div>
            <input
              type="checkbox"
              className="u-spaceTopSm"
              name="addLegacySeason"
              onClick={() => setAddLegacySeasons(!addLegacySeasons)}
              onChange={() => {}}
              checked={addLegacySeasons || hasLegacySeasonConnected}
              disabled={hasLegacySeasonConnected}
            />
            <label htmlFor="addLegacySeason">Add legacy seasons to new organization</label>
          </div>
        </Cell>
      </Grid>
    </PanelCell>
  </PanelRow>
);

export default OrgEditLegacySeasonField;
